<template>
<div>
    <div v-if="isLoading" class="center pt-5">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <DeptoBase
    :goal="moldeo.meta_semana"
    :progress="moldeo.progress"
    :name="moldeo.nombre"
    :depto="moldeo.depto"
    :days="moldeo.dias_laborados"
    :m3="moldeo.m3_persona"
    :bonus_p="moldeo.bono_persona"
    :bonus_tot="moldeo.bono_depto"
    :asis="moldeo.asistencia"
    :extra="moldeo.$_extra_m3"
    :bonus_prod="moldeo.bono_productividad"
    :bonus_goals="moldeo.bono_metas"
    :descuento="moldeo.descuento_fr"
    />
</div>
</template>


<script>

import DeptoBase from '@/components/DeptoBase';

export default {
    name: 'Moldeo',
    components: {DeptoBase},
    created() {
        this.$store.dispatch("plants/getInfo", {
            department: 'moldeo',
            userCode: this.$route.params.user,
            city: 'rosarito'
        }); 
    },
    computed: {
        isLoading() {
            return this.$store.getters["plants/loading"];
        },
        moldeo() {
        return this.$store.getters["plants/data"];
        }
    }
}

</script>